module.exports = __webpack_public_path__ + "img/tick.cd3e9e74.svg";